import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "global-main"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_view = _resolveComponent("router-view");
  const _component_van_tabbar_item = _resolveComponent("van-tabbar-item");
  const _component_van_tabbar = _resolveComponent("van-tabbar");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_router_view, null, {
    default: _withCtx(({
      Component
    }) => [(_openBlock(), _createBlock(_resolveDynamicComponent(Component)))]),
    _: 1
  }), _createVNode(_component_van_tabbar, {
    class: "global-tabbar",
    "active-color": "#CF1421",
    route: "",
    fixed: "",
    placeholder: true,
    border: false
  }, {
    default: _withCtx(() => [_createVNode(_component_van_tabbar_item, {
      replace: "",
      to: "/dashboard",
      "icon-prefix": "jk-icon",
      icon: "shouye"
    }, {
      default: _withCtx(() => _cache[0] || (_cache[0] = [_createTextVNode("首页")])),
      _: 1
    }), _createVNode(_component_van_tabbar_item, {
      replace: "",
      to: "/goods",
      "icon-prefix": "jk-icon",
      icon: "quanbu"
    }, {
      default: _withCtx(() => _cache[1] || (_cache[1] = [_createTextVNode("全部游戏")])),
      _: 1
    }), _createVNode(_component_van_tabbar_item, {
      replace: "",
      to: "/user",
      "icon-prefix": "jk-icon",
      icon: "yonghu1"
    }, {
      default: _withCtx(() => _cache[2] || (_cache[2] = [_createTextVNode("我的")])),
      _: 1
    })]),
    _: 1
  })]);
}